const isValidPaymentMethod = (selectedPaymentMethod, stepPaymentState)=>{
    return !!stepPaymentState && !!selectedPaymentMethod && stepPaymentState.filter((resultStates)=>resultStates.name === selectedPaymentMethod.type
    ).length !== 0;
};

export { isValidPaymentMethod };
//# sourceMappingURL=is-valid-payment-method.js.map
